import { Injectable, inject } from '@angular/core';
import {
  IBeacon,
  ICreateBeacon,
  IListado,
  IQueryParam,
  IUpdateControl,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from '../../auxiliares/servicios/helper.service';
import { HttpApiAdminService } from '../../auxiliares/servicios/http-api.service';

@Injectable({
  providedIn: 'root',
})
export class ControlesBTService {
  private http = inject(HttpApiAdminService);
  private helper = inject(HelperService);

  public listar(queryParams?: IQueryParam): Observable<IListado<IBeacon>> {
    const params = this.helper.getQueryParams(queryParams);
    return this.http.get(`/beacons`, { params });
  }

  public listarPorId(id: string): Observable<IBeacon> {
    return this.http.get(`/beacons/${id}`);
  }

  public crear(dato: ICreateBeacon): Observable<IBeacon> {
    return this.http.post(`/beacons`, dato);
  }

  public editar(id: string, dato: IUpdateControl): Observable<IBeacon> {
    return this.http.put(`/beacons/${id}`, dato);
  }

  public eliminar(id: string): Observable<IBeacon> {
    return this.http.delete(`/beacons/${id}`);
  }
}
